import { render, staticRenderFns } from "./MatchedDriverLabel.vue?vue&type=template&id=06d1052e&scoped=true&"
import script from "./MatchedDriverLabel.vue?vue&type=script&lang=js&"
export * from "./MatchedDriverLabel.vue?vue&type=script&lang=js&"
import style0 from "./MatchedDriverLabel.vue?vue&type=style&index=0&id=06d1052e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1052e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VTooltip})
